<div class="uk-section-default uk-section uk-section-small uk-padding-remove-bottom" style="min-height: 700px">
  <div class="uk-container">

    <h1 class="uk-text-center">Welcome to the EOSC Service Catalogue</h1>

    <!--    <div class="uk-padding uk-padding-remove-left uk-padding-remove-right">-->
    <!--      <div class="services-provider-container">-->
    <!--        <p class="uk-margin-remove-bottom">EOSC is being upgraded! New and better features have been developed and are ready for production. We will upgrade various services and components of EOSC on Thursday 30 November 2023. On that day there may be brief disruptions to services you use, but the features and capabilities that are available today will continue to be there, and additional capabilities that you have been asking for will become available. Once the upgrade is complete, we will provide more details about what has been improved and what is brand new.-->

    <!--          If you DO experience any difficulties at this time, please contact the EOSC Helpdesk at <a href="mailto:help@eosc-portal.eu">help@eosc-portal.eu</a>.-->

    <!--          Thank you for your patience during this period.</p>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="uk-padding uk-padding-remove-left uk-padding-remove-right" style="padding-bottom: 10px;">
      <div class="services-provider-container">
        <p class="uk-margin-remove-bottom">Updated information, documentation, and instructions for onboarding resources can be found in the new <a href="https://docs.sandbox.eosc-beyond.eu/" target="_blank">Providers Hub</a> section of eosc-beyond.eu.</p>
      </div>
    </div>

    <div class="uk-padding uk-padding-remove-left uk-padding-remove-right uk-margin-bottom" style="padding-top: 0px;">
      <div class="services-provider-container">
        <p class="uk-margin-remove-bottom">If you have any issues or need assistance, please visit our <a [routerLink]="['/helpdesk/create']" class="helpdesk-link">Helpdesk</a> for support and guidance.</p>
      </div>
    </div>

    <p>
      A single platform for providers to onboard their organization into EOSC portal, register and manage their resources and gain rich insights about their offerings in the catalogue.
    </p>

    <div class="uk-grid uk-grid-match uk-child-width-1-3 uk-margin-large-top uk-margin-large-bottom">

      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <img src="../../../assets/images/EOSC_Onboarding_1546x800-min.png" style="height: 209px">
          </div>
          <div class="uk-card-body uk-flex uk-flex-column uk-flex-between" style="min-height: 311px">
            <div>
              <h3 class="uk-card-title">Onboarding of Resources</h3>
              <p>Self service, Workflow based</p>
            </div>
            <div>
              <button class="uk-button uk-button-primary" [routerLink]="'/becomeAProvider'">Learn more</button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <img src="../../../assets/images/EOSC_Dashboard_1532x800-min.png" style="height: 209px">
          </div>
          <div class="uk-card-body uk-flex uk-flex-column uk-flex-between" style="min-height: 311px">
            <div>
              <h3 class="uk-card-title">Provider Dashboard</h3>
              <p>Gain full control of your resources in the catalogue</p>
            </div>
            <div>
              <button class="uk-button uk-button-primary" [routerLink]="'/provider/my'">Learn more</button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="uk-card uk-card-default">
          <div class="uk-card-media-top">
            <img src="../../../assets/images/EOSC_APIs_1422x800-min.png">
          </div>
          <div class="uk-card-body uk-flex uk-flex-column uk-flex-between" style="min-height: 300px">
            <div>
              <h3 class="uk-card-title">Application Programming Interfaces (APIs)</h3>
              <p>Programmatic management of resources</p>
            </div>
            <div>
              <button class="uk-button uk-button-primary" [routerLink]="'/developers'">Learn more</button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
